import { type FC } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { CardGridArea, Tag } from "widgets";

import { type IAaFeatureState } from "../../redux/modules/aaFeature.js";
import { type IAppState } from "../../redux/reducer.js";
import { AttributesListWidget } from "../core/navigation-panel/AttributeWidget.js";
import GenericEntitySummaryView from "./GenericEntitySummaryView.js";
import { AaFeatureCard } from "./cards/AaFeatureCard.js";
import { DatabaseCard } from "./cards/DatabaseCard.js";
import { GenomeCard } from "./cards/GenomeCard.js";
import { renderAaFeatureAttributesWidgets } from "@/app-utils/attributes-widgets.tsx";

interface IAaFeatureSummaryViewProps {
  title?: string;
}

const AaFeatureSummaryView: FC<IAaFeatureSummaryViewProps> = (props) => {
  const { aaFeature, isLoading } = useSelector<IAppState, IAaFeatureState>((state) => state.aaFeature, shallowEqual);

  //const currentUser = useSelector<IAppState, User>((state) => state.auth.session, shallowEqual);

  return (
    <GenericEntitySummaryView
      title={(props.title ? `${props.title}: ` : "") + (aaFeature ? aaFeature.name : "")}
      subtitle={aaFeature?.description || "Amino Acid Feature Summary"}
      entity={aaFeature}
      refGenomes={undefined}
      headerAttributes={[
        <AttributesListWidget
          attributes={renderAaFeatureAttributesWidgets(aaFeature)}
          key={"aaFeature-summary-view-widget-1"}
        />,
      ]}
      headerTags={[
        <Tag key={"aaFeature-summary-view-tag-1"} intentColor={aaFeature?.aaFeatureType?.color}>
          {aaFeature?.aaFeatureType.name}
        </Tag>,
      ]}
      isLoading={isLoading}
      getEntityName={() => aaFeature?.name}
    >
      {aaFeature && (
        <>
          <AaFeatureCard aaFeature={aaFeature} area={CardGridArea.Left} />
          {aaFeature.region && (
            <DatabaseCard
              genome={aaFeature.genome}
              database={aaFeature.region?.contig.database}
              area={CardGridArea.Left}
            />
          )}
          <GenomeCard genome={aaFeature.genome} area={CardGridArea.Right} />
        </>
      )}
    </GenericEntitySummaryView>
  );
};

export default AaFeatureSummaryView;
